import React from "react";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import "./radio-button.scss";

const RadioIcon = () => (
  <svg
    className="radio-icon"
    data-name="Radio button"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
  >
    <g data-name="Group 4222" transform="translate(-1 -47)">
      <g data-name="Group 2114" transform="translate(-576.805 -1026.613)">
        <g
          data-name="Ellipse 145"
          transform="translate(577.805 1073.613)"
          fill="#fff"
          stroke="#1e222f"
          strokeWidth="1"
        >
          <circle cx="12" cy="12" r="11" stroke="none" />
          <circle cx="12" cy="12" r="10.5" fill="none" />
        </g>
      </g>
    </g>
  </svg>
);

const RadioIconChecked = () => (
  <svg
    className="radio-icon--checked"
    data-name="Radio button"
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="22"
    viewBox="0 0 24 24"
  >
    <g data-name="Group 4222" transform="translate(-1 -47)">
      <g data-name="Group 1994" transform="translate(-576.805 -1026.613)">
        <g
          data-name="Ellipse 146"
          transform="translate(577.805 1073.613)"
          fill="#fff"
          stroke="#1e222f"
          strokeWidth="1"
        >
          <circle cx="12" cy="12" r="11" stroke="none" />
          <circle cx="12" cy="12" r="10.5" fill="none" />
        </g>
        <g
          data-name="Ellipse 150"
          transform="translate(582.805 1078.613)"
          fill="#1e222f"
          stroke="#1e222f"
          strokeWidth="1"
        >
          <circle cx="7" cy="7" r="6" stroke="none" />
          <circle cx="7" cy="7" r="5.5" fill="none" />
        </g>
      </g>
    </g>
    <g
      data-name="Ellipse 149"
      transform="translate(5 5)"
      fill="#1e222f"
      stroke="#1e222f"
      strokeWidth="1"
    >
      <circle cx="7" cy="7" r="6" stroke="none" />
      <circle cx="7" cy="7" r="5.5" fill="none" />
    </g>
  </svg>
);

export type RadioButtonOption = {
  value: string;
  label: string;
};

export type RadioButtonProps = {
  option: RadioButtonOption;
  tabIndex: number;
};

export const RadioButton: React.FC<RadioButtonProps> = ({
  option,
  tabIndex,
}: RadioButtonProps) => {
  return (
    <FormControlLabel
      value={option.value}
      control={
        <Radio
          disableRipple
          icon={<RadioIcon />}
          checkedIcon={<RadioIconChecked />}
        />
      }
      label={option.label}
      tabIndex={tabIndex}
    />
  );
};
